export default {
  path: 'product-type',
  component: () => import('@/views/settingSystem/setting-router.vue'),
  children: [
    {
      path: '',
      name: 'ProductTypeList',
      component: () => import('@/views/settingSystem/pages/product-type/ProductTypeList.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'create',
      name: 'ProductTypeCreate',
      component: () => import('@/views/settingSystem/pages/product-type/ProductTypeCreate.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'edit/:id',
      name: 'ProductTypeEdit',
      component: () => import('@/views/settingSystem/pages/product-type/ProductTypeEdit.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    }
  ]
}
